export default __webpack_public_path__ + "media/images/banner/banner-17-7bfec8f810c30fc2bc00bcf2d9d14280.jpg";